// FAT-12: estado "dados insuficientes" no lugar do sinal quando o indicador ainda não está pronto (warm-up).
// O backend marca `dadosInsuficientes`/`prontidao.pronto === false`; a tela nunca mostra número parcial,
// 0,00% nem sinal nesse caso. Não informa quantos pregões faltam.
import React from 'react';
import './DadosInsuficientes.css';

export const TEXTO_DADOS_INSUFICIENTES = 'Dados insuficientes';

export function semProntidao(item) {
  return item?.dadosInsuficientes === true || item?.prontidao?.pronto === false;
}

export default function DadosInsuficientes({ testId = 'dados-insuficientes', title }) {
  return (
    <span
      className="di-badge"
      data-testid={testId}
      title={title || 'Indicadores ainda sem histórico mínimo: nenhum sinal é gerado.'}
    >
      {TEXTO_DADOS_INSUFICIENTES}
    </span>
  );
}
